module.exports = __webpack_public_path__ + "ui-static/img/empty_dark.d562ceaa.svg";